import script from "./CloseButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CloseButton.vue?vue&type=script&setup=true&lang=ts"

import "./CloseButton.vue?vue&type=style&index=0&id=be0d3934&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/ClementRivaille.github.io/ClementRivaille.github.io/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be0d3934"]])

export default __exports__